import { createRuntime } from '@livefree/runtime';
import { ShellConfig } from './config';
import { initAuthRuntime } from '@livefree/auth-app';
import { initTicketingRuntime } from '@livefree/ticketing-app';
import { initTransactionsRuntime } from '@livefree/transactions-app';
import { initAccountsRuntime } from '@livefree/accounts-app';
import { initCellularRuntime } from '@livefree/cellular-app';
import { initDevicesRuntime } from '@livefree/devices-app';
import { initNotificationsRuntime } from '@livefree/notifications-app';
import { initSalesRuntime } from '@livefree/sales-app';
import { initRemindersRuntime } from '@livefree/reminders-app';
import { initBillingRuntime } from '@livefree/billing-app';
import { initSubscriptionsRuntime } from '@livefree/subscriptions-app';
import { initProductsRuntime } from '@livefree/products-app';
import { initCollectionsRuntime } from '@livefree/collections-app';

export const hostRuntime = createRuntime({
  hostConfig: ShellConfig,
});

initProductsRuntime(hostRuntime);
initSalesRuntime(hostRuntime);
initAccountsRuntime(hostRuntime);
initSubscriptionsRuntime(hostRuntime);
initCollectionsRuntime(hostRuntime);
initTransactionsRuntime(hostRuntime);
initDevicesRuntime(hostRuntime);
initNotificationsRuntime(hostRuntime);
initBillingRuntime(hostRuntime);
initTicketingRuntime(hostRuntime);
initRemindersRuntime(hostRuntime);
initAuthRuntime(hostRuntime);
initCellularRuntime(hostRuntime);
